import { PolicyTransactionSearchResponse, PolicySearchResponse, QuoteSearchResponse } from '@lio/api-types';
import { ArrayItem } from '@utils/commonTypes';

export enum RelatedTransactionsTab {
  Policy = 'policy',
  Customer = 'customer',
}

export type PolicyTransactionItem = ArrayItem<PolicyTransactionSearchResponse['items']>;
export type PolicyItem = ArrayItem<PolicySearchResponse['items']>;
export type QuoteItem = ArrayItem<QuoteSearchResponse['items']>;

export interface ITermGroup {
  termNumber: string;
  transactions: PolicyTransactionItem[];
}
